import service from "@/utils/request.js"

// 联系我们
export function contactUs(data){
	return service.request({
		url:'/basic/app/api/bannerUserMsg/userAddMsg',
		method:'POST',
		data
	})
}
